import { Component, Input, OnInit, OnChanges, AfterViewInit, forwardRef, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import {
	NG_VALUE_ACCESSOR,
	ControlValueAccessor
} from '@angular/forms';

@Component({
	selector: 'app-large-input',
	templateUrl: './large-input.component.html',
	styleUrls: ['./large-input.component.scss'],
	host: { class: 'app-large-input' },
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			multi: true,
			useExisting: forwardRef(() => LargeInputComponent)
		}
	]
})
export class LargeInputComponent implements OnInit, OnChanges, AfterViewInit, ControlValueAccessor {
	@Input() id;
	@Input() label;
	@Input() placeholderLabel;
	@Input() placeholder;
	@Input() icon;
	@Input() required = false;
	@Input() minlength;
	@Input() maxlength;
	@Input() inputValue = '';
	@Input() disabled = false;
	@Input() errorMessage;
	@Input() hasError;
	@Input() prefix = null;
	@Input() isLoading = false;
	@Input() ariaDescribedby = null;
	@Input() readonly = false;

	isFilled = false;
	isFocused = false;
	
	private prefixElem: ElementRef;
	@ViewChild('prefixElemRef') set content(content: ElementRef) {
		this.prefixElem = content;
	 }

	constructor(private cdr: ChangeDetectorRef) {}

	ngOnInit() {
		this.TAP_checkIfFilled();
	}
	
	ngOnChanges() {
		this.TAP_checkIfFilled();
	}
	
	TAP_checkIfFilled() {
		if (this.inputValue !== '') {
			this.isFilled = true;
		} else {
			this.isFilled = false;
		}
	}
	
	ngAfterViewInit() {
	  this.cdr.detectChanges();
	}

	change($event) {
		this.inputValue = $event.target.value;
	}
	TAP_printID() {
		return this.id;
	}

	TAP_printIcon() {
		return this.icon;
	}

	TAP_printLabel() {
		return this.placeholderLabel && !this.isFilled ? this.placeholderLabel : this.label;
	}

	TAP_printStyle() {
		return {
			'is-filled': this.isFilled && !this.isLoading,
			'is-loading': this.isLoading,
			'is-focused': this.isFocused,
			'is-disabled': this.disabled && !this.isLoading,
			'has-error' : this.hasError,
			'has-icon' : this.icon
		};
	}
	
	TAP_printPadding() {
		if (this.prefix === null || this.prefixElem === undefined) {
			return null;
		} else {
			return {
				paddingLeft: (this.prefixElem.nativeElement.offsetWidth + 4) + 'px'
			}
		}
	}

	TAP_handleFocus($event) {
		this.isFocused = true;
	}

	TAP_handleBlur($event) {
		this.isFocused = false;
		if ($event.target.value !== '') {
			this.isFilled = true;
		} else {
			this.isFilled = false;
		}
		this.writeValue($event.target.value);
	}

	TAP_showError() {
		return this.hasError;
	}

	// Function to call when the rating changes.
	onChange = (value) => {};

	// Function to call when the input is touched (when a star is clicked).
	onTouched = () => {};

	// Allows Angular to update the model (rating).
	// Update the model and changes needed for the view here.
	writeValue(value): void {
		this.onChange(value);
	}

	// Allows Angular to register a function to call when the model (rating) changes.
	// Save the function as a property to call later here.
	registerOnChange(fn: (rating: number) => void): void {
		this.onChange = fn;
	}

	// Allows Angular to register a function to call when the input has been touched.
	// Save the function as a property to call later here.
	registerOnTouched(fn: () => void): void {
		this.onTouched = fn;
	}

	// Allows Angular to disable the input.
	setDisabledState(isDisabled: boolean): void {
		this.disabled = isDisabled;
	}

	TAP_printError() {
		return this.errorMessage;
	}

	TAP_isRequired() {
		return this.required;
	}
}
